import { FiSearch } from "react-icons/fi";

export default function AttendanceFilters({
  search,
  setSearch,
  status,
  setStatus,
  selectedDate,
  setSelectedDate,
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="relative flex-1">
          <FiSearch
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
            size={18}
          />

          <input
            type="text"
            placeholder="Search by employee name or ID..."
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-800 focus:border-primary-800"
          />
        </div>

        <input
          type="date"
          value={selectedDate}
          onChange={(event) => setSelectedDate(event.target.value)}
          className="px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-800 focus:border-primary-800"
        />

        <select
          value={status}
          onChange={(event) => setStatus(event.target.value)}
          className="px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-800 focus:border-primary-800"
        >
          <option value="All">All Statuses</option>
          <option value="Present">Present</option>
          <option value="Late">Late</option>
          <option value="Absent">Absent</option>
          <option value="On Leave">On Leave</option>
          <option value="Half Day">Half Day</option>
          <option value="Weekly Off">Weekly Off</option>
          <option value="Holiday">Holiday</option>
        </select>
      </div>
    </div>
  );
}